import React, { useState, useEffect } from 'react';
import { MsalAuthenticationTemplate, withMsal, useMsal } from "@azure/msal-react";
import * as msal from "@azure/msal-browser";

export const generateMsalConfig = (config) => {
    const msalAppConfig = {};
    //const tenantSubdomain = config.tenant.split('.')[0]
    //const instance = `https://${tenantSubdomain}.b2clogin.com/`
    const authority = `${config.domain}/${config.tenant}/${config.signInPolicy}`

    msalAppConfig.auth = {};
    msalAppConfig.auth.clientId = config.clientId;
    msalAppConfig.auth.authority = authority;
    msalAppConfig.auth.tenant = config.tenant;
    msalAppConfig.auth.tenantID = config.tenantID;
    msalAppConfig.auth.domain = config.domain;
    

    msalAppConfig.auth.knownAuthorities = [authority];
    msalAppConfig.auth.redirectUri = config.redirectUri;
    msalAppConfig.auth.postLogoutRedirectUri = config.postLogoutRedirectUri;
    
    msalAppConfig.cache = {};
    msalAppConfig.cache.cacheLocation = config.cacheLocation;

    return msalAppConfig;
};

export const getResetPasswordRequest = (config) => {
    //const tenantSubdomain = config.tenant.split('.')[0]
    //const instance = `https://${tenantSubdomain}.b2clogin.com/`
    const authority = `${config.domain}/${config.tenant}/${config.resetPasswordPolicy}`

    return { authority: authority };
};